import ArrowSvg from 'images/shared/arrow.svg';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Loader } from '../components';
import { css } from '@emotion/react';

const StepButtonBase = props => css`
  position: relative;
  display: flex;
  align-items: center;
  height: 24px;

  font-family: ${props.theme.fontFamily};
  font-weight: 600;
  line-height: 12px;
  font-size: 14px;

  cursor: pointer;
  border: none;
  outline: none;

  div {
    width: 24px;
    height: 24px;
  }

  svg {
    display: block;
    width: 24px;
    height: 24px;
  }
`;

const PreviousStep = styled.button`
  ${StepButtonBase};
  color: ${props => props.theme.primaryFontColor};

  svg {
    margin-right: 8px;
    fill: ${props => props.theme.secondaryColor};
    transform: rotate(180deg);
    .arrow_svg__arrow { fill:  ${props => props.theme.primaryFontColor} }
  }
`;

const NextStep = styled.button`
  ${StepButtonBase};
  color: ${props => props.theme.highlightColor};
  svg {
    margin-left: 8px;
    fill: ${props => props.theme.highlightColor};
    .arrow_svg__arrow { fill:  ${props => props.theme.secondaryFontColor} }
  }
`;

PreviousStep.defaultProps = {
  type: 'button',
};

NextStep.defaultProps = {
  type: 'submit',
};

const PreviousStepButton = ({ children, handleClick, className }) => (
  <PreviousStep onClick={handleClick} className={className} >
    <ArrowSvg />
    {children}
  </PreviousStep>
);

const NextStepButton = ({ children, loading, handleClick, as, className, type }) => (
  <NextStep onClick={handleClick} as={as} className={className} type={type} >
    {children}
    {loading
      ? <Loader css={css`margin: 0; margin-left: 8px;`} />
      : <ArrowSvg />}
  </NextStep>
);

PreviousStepButton.propTypes = {
  children: PropTypes.any,
  handleClick: PropTypes.func
};

PreviousStepButton.defaultProps = {
  children: null,
  handleClick: () => {},
}

NextStepButton.propTypes = {
  children: PropTypes.any,
  handleClick: PropTypes.func,
  loading: PropTypes.bool,
  as: PropTypes.string,
};

NextStepButton.defaultProps = {
  children: null,
  handleClick: () => {},
  loading: false,
  as: null
}

export {
  StepButtonBase,
  PreviousStepButton,
  NextStepButton,
}
